import React, { useEffect } from "react";
import * as S from "./Home.styled";
import { Input } from "../../components";
import { LandingHeader } from "../../components/LandingHeader";
import { LandingHero } from "../../components/LandingHero";
import { CookieNotice } from "../../components";
import { useNavigate } from "react-router-dom";
import { useAssistantChat } from "../../context";
import DescriptionBackgroundPattern from "./description-background-pattern.svg";
import { LandingFooter } from "../../components/LandingFooter";
import TryItOut from "./try-it-out.svg";

const FiltersGraphic = () => {
  return (
    <svg
      width="93"
      height="28"
      viewBox="0 0 93 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.11896"
        y="1.50421"
        width="90.4176"
        height="25.3542"
        rx="2.43817"
        fill="#ED430B"
        stroke="white"
        stroke-width="1.12366"
      />
      <path
        d="M78.9958 16.6699L82.3328 13.0578H75.6588L78.9958 16.6699Z"
        fill="white"
      />
      <path
        d="M13.2694 9.89127V7.55169H19.1277V9.89127H13.2694ZM13.2694 15.0571V12.8298H18.9405V15.0571H13.2694ZM11.5475 7.55169H14.1304V20.6533H11.5475V7.55169ZM20.6837 8.71212C20.6837 8.31283 20.8271 7.98841 21.1141 7.73886C21.4011 7.47682 21.7443 7.34581 22.1436 7.34581C22.5428 7.34581 22.8797 7.47682 23.1542 7.73886C23.4412 7.98841 23.5847 8.31283 23.5847 8.71212C23.5847 9.09893 23.4412 9.42335 23.1542 9.68539C22.8797 9.94742 22.5428 10.0784 22.1436 10.0784C21.7443 10.0784 21.4011 9.94742 21.1141 9.68539C20.8271 9.42335 20.6837 9.09893 20.6837 8.71212ZM20.9457 12.0437H23.304V20.6533H20.9457V12.0437ZM25.3157 6.05436H27.7489V20.6533H25.3157V6.05436ZM28.4753 12.0437H33.7908V14.0838H28.4753V12.0437ZM29.9539 9.04902H32.2935V20.6533H29.9539V9.04902ZM38.5813 20.8405C37.6454 20.8405 36.8281 20.6533 36.1294 20.279C35.4306 19.9047 34.8879 19.3868 34.501 18.7255C34.1267 18.0517 33.9395 17.2594 33.9395 16.3485C33.9395 15.4251 34.1267 14.6328 34.501 13.9715C34.8879 13.2977 35.4306 12.7799 36.1294 12.418C36.8281 12.0437 37.6517 11.8565 38.6 11.8565C39.5483 11.8565 40.3531 12.0312 41.0144 12.3806C41.6882 12.7175 42.1998 13.2166 42.5492 13.8779C42.8986 14.5267 43.0733 15.3128 43.0733 16.2362C43.0733 16.3485 43.067 16.467 43.0545 16.5918C43.0545 16.7166 43.0483 16.8164 43.0358 16.8913H35.3246V15.394H40.9208L40.2658 16.2549C40.3157 16.18 40.3593 16.0802 40.3968 15.9555C40.4467 15.8182 40.4716 15.7059 40.4716 15.6186C40.4716 15.1943 40.3905 14.8325 40.2283 14.533C40.0786 14.2335 39.8602 13.9964 39.5733 13.8218C39.2863 13.6471 38.9494 13.5597 38.5626 13.5597C38.0884 13.5597 37.6891 13.6658 37.3647 13.8779C37.0527 14.0776 36.8094 14.3833 36.6347 14.795C36.4725 15.1943 36.3852 15.6934 36.3727 16.2923C36.3727 16.8663 36.4538 17.353 36.616 17.7522C36.7907 18.1515 37.0465 18.4572 37.3834 18.6694C37.7203 18.8815 38.1258 18.9875 38.6 18.9875C39.1365 18.9875 39.592 18.8877 39.9663 18.6881C40.3531 18.476 40.6713 18.164 40.9208 17.7522L43.0358 18.4073C42.5866 19.2184 41.9877 19.8298 41.239 20.2416C40.5028 20.6408 39.6169 20.8405 38.5813 20.8405ZM46.7171 12.0437V20.6533H44.3401V12.0437H46.7171ZM49.2439 14.5704C49.0817 14.4207 48.9132 14.3084 48.7385 14.2335C48.5763 14.1462 48.3704 14.1025 48.1209 14.1025C47.8214 14.1025 47.5656 14.1836 47.3535 14.3458C47.1414 14.508 46.9792 14.7389 46.8669 15.0383C46.7671 15.3253 46.7171 15.6747 46.7171 16.0865L46.0433 15.4127C46.0433 14.7264 46.1744 14.1212 46.4364 13.5972C46.6984 13.0606 47.0416 12.6364 47.4658 12.3244C47.8901 12 48.3268 11.8378 48.776 11.8378C49.0879 11.8378 49.3811 11.8939 49.6557 12.0062C49.9426 12.1185 50.1735 12.287 50.3482 12.5116L49.2439 14.5704ZM51.502 17.6774C51.8639 18.0143 52.2008 18.2888 52.5127 18.5009C52.8247 18.7006 53.1179 18.8503 53.3924 18.9501C53.6794 19.0499 53.9477 19.0998 54.1972 19.0998C54.5216 19.0998 54.7712 19.0312 54.9459 18.894C55.1206 18.7442 55.2079 18.5446 55.2079 18.295C55.2079 18.0704 55.133 17.8833 54.9833 17.7335C54.8461 17.5713 54.6402 17.4278 54.3657 17.303C54.0911 17.1783 53.7418 17.0473 53.3175 16.91C52.9182 16.7603 52.5314 16.5856 52.1571 16.3859C51.7828 16.1738 51.4708 15.8993 51.2213 15.5624C50.9842 15.213 50.8657 14.7701 50.8657 14.2335C50.8657 13.7219 51.0029 13.2915 51.2774 12.9421C51.5519 12.5802 51.92 12.312 52.3817 12.1373C52.8559 11.9501 53.3799 11.8565 53.9539 11.8565C54.4405 11.8565 54.896 11.9189 55.3202 12.0437C55.7445 12.1685 56.1375 12.3369 56.4994 12.549C56.8612 12.7487 57.1794 12.9857 57.4539 13.2603L56.3871 14.7576C56.0751 14.4207 55.7008 14.1462 55.2641 13.9341C54.8398 13.7219 54.4218 13.6159 54.01 13.6159C53.7355 13.6159 53.5172 13.672 53.355 13.7843C53.2052 13.8841 53.1304 14.0401 53.1304 14.2522C53.1304 14.4394 53.2052 14.6079 53.355 14.7576C53.5172 14.8948 53.7418 15.0196 54.0288 15.1319C54.3282 15.2442 54.6651 15.3815 55.0395 15.5437C55.5011 15.7184 55.9254 15.918 56.3122 16.1426C56.7115 16.3547 57.0297 16.623 57.2667 16.9474C57.5038 17.2719 57.6224 17.6961 57.6224 18.2202C57.6224 19.0811 57.3416 19.7549 56.7801 20.2416C56.2186 20.7157 55.445 20.9528 54.4592 20.9528C53.8478 20.9528 53.2863 20.8717 52.7747 20.7095C52.2756 20.5473 51.8202 20.3351 51.4084 20.0731C51.0091 19.7986 50.6473 19.5054 50.3229 19.1934L51.502 17.6774ZM65.3795 11.295C65.3795 10.8708 65.2859 10.5152 65.0988 10.2282C64.9116 9.94118 64.6433 9.72282 64.2939 9.57309C63.957 9.41088 63.5515 9.32977 63.0774 9.32977C62.4909 9.32977 61.9481 9.47326 61.449 9.76025C60.9499 10.0348 60.5319 10.4278 60.195 10.9394L58.4918 9.61052C58.8911 9.11141 59.3153 8.68717 59.7645 8.33779C60.2137 7.98841 60.7253 7.72014 61.2993 7.53297C61.8733 7.34581 62.5283 7.25223 63.2645 7.25223C63.8635 7.25223 64.4312 7.34581 64.9677 7.53297C65.5168 7.72014 66.0034 7.99465 66.4276 8.35651C66.8644 8.70588 67.2013 9.13013 67.4383 9.62924C67.6879 10.1159 67.8127 10.6711 67.8127 11.295C67.8127 12.0437 67.6193 12.705 67.2325 13.279C66.8581 13.8405 66.3653 14.2959 65.7538 14.6453C65.1424 14.9822 64.4998 15.1943 63.826 15.2817L63.7137 17.0784H61.7859L61.4116 13.7469H61.9918C62.7405 13.7469 63.3644 13.6221 63.8635 13.3726C64.3751 13.1105 64.7556 12.7923 65.0052 12.418C65.2547 12.0312 65.3795 11.6569 65.3795 11.295ZM61.2431 19.6613C61.2431 19.287 61.3866 18.9626 61.6736 18.6881C61.9731 18.4136 62.3412 18.2763 62.7779 18.2763C63.2271 18.2763 63.5952 18.4136 63.8822 18.6881C64.1692 18.9626 64.3127 19.287 64.3127 19.6613C64.3127 20.0357 64.1692 20.3601 63.8822 20.6346C63.5952 20.9091 63.2271 21.0464 62.7779 21.0464C62.3412 21.0464 61.9731 20.9091 61.6736 20.6346C61.3866 20.3601 61.2431 20.0357 61.2431 19.6613Z"
        fill="white"
      />
    </svg>
  );
};

export const Home = () => {
  const suggestions = [
    "Help me find top cars for city driving",
    "Show me cars with the best fuel economy under 20.000€",
    "I need a car with top rated safety features that’s affordable",
    "I’m interested in reliable used cars in red color",
  ];

  const navigate = useNavigate();
  const { thread, createNewConversation } = useAssistantChat();
  const [inputValue, setInputValue] = React.useState("");
  const [showCookieNotice, setShowCookieNotice] = React.useState(false);

  const handleSuggestionsClick = async (suggestion: string) => {
    if (thread === "" || thread === undefined) {
      await createNewConversation();
    }
    navigate("/chat", { replace: true, state: { message: suggestion } });
  };

  const handleSendMessage = async () => {
    if (thread === "" || thread === undefined) {
      await createNewConversation();
    }
    setInputValue("");
    navigate("/chat", { replace: true, state: { message: inputValue } });
  };

  useEffect(() => {
    if (thread) {
      navigate("/chat", { replace: true });
    }
  }, [thread]);

  useEffect(() => {
    if (document.cookie.includes("cookieCons=true")) {
      setShowCookieNotice(false);
    } else {
      setShowCookieNotice(true);
    }
  }, []);

  const acceptCookies = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    document.cookie = `cookieCons = true; expires = ${date.toUTCString()}; path=/`;
    setShowCookieNotice(false);
  };

  return (
    <S.Home>
      <LandingHeader />
      <S.PageContent>
        <LandingHero />
        <S.LandingHeading>
          <h2>Your AI Powered Car Shopping Assistant</h2>
        </S.LandingHeading>
        <S.LandingDescriptionContainer>
          <S.LandingDescriptionTitleContainer>
            <FiltersGraphic />
            <h2>No more!</h2>
          </S.LandingDescriptionTitleContainer>
          <S.LandingDescription>
            supra<b>chat</b> {" eliminates filter frustration with its "}{" "}
            <b>natural conversational approach</b>
            {", turning visitors into buyers."}
          </S.LandingDescription>
          <S.BackgroundPattern
            src={DescriptionBackgroundPattern}
            alt="Background Pattern"
          />
        </S.LandingDescriptionContainer>

        <S.InputWrapper>
          <S.InputTitleLabel>
            <img src={TryItOut} alt={"Try it out"} />
          </S.InputTitleLabel>
          <Input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Start conversation..."
            onKeyDown={(e) =>
              e.key === "Enter" && inputValue && handleSendMessage()
            }
            isDisabled={inputValue.length === 0}
            onSend={handleSendMessage}
            focusInput={(input) => input && input.focus()}
          />
        </S.InputWrapper>
        <S.SuggestionsContainer>
          <label>Try searching</label>
          {suggestions.map((suggestion, index) => (
            <S.Suggestion
              key={index}
              onClick={() => handleSuggestionsClick(suggestion)}
            >
              {suggestion}
            </S.Suggestion>
          ))}
        </S.SuggestionsContainer>
        <LandingFooter />
      </S.PageContent>
      {showCookieNotice && <CookieNotice onClick={acceptCookies} />}
    </S.Home>
  );
};
